export class ShortcodeManger {
    constructor() {
        requestAnimationFrame(() => {
            this.setIframeHeight();
            this.initEvents();
        });
    }

    private initEvents(): void {
        // wenn der address dialog auf mobil innerhalb des shortcodes aufgerufen wird, soll eine hoehe gesetzt werden, damit der Benutzer im dialog nicht scrollen muss
        document.addEventListener('sl-show', () => {
            let dialog = document.querySelector('.dsl-address-dialog');
            if (!dialog) {
                return;
            }
            // der Adress-Dialog hat ein feste hoehe, wir machen hier den iframe so gross, dass der dialog die komplette hoehe nutzen kann
            this.setIframeHeight(650);
        });

        // nach dem schliessen des dialogs soll die hoehe wieder neu gesetzt werden
        document.addEventListener('sl-after-hide', () => {
            let dialog = document.querySelector('.dsl-address-dialog');
            if (!dialog) {
                return;
            }

            this.setIframeHeight();
        });
    }

    private setIframeHeight(size: number = 0): void {
        // Nur ausfuehren, wenn wir im Kontext von shortcode sind:
        let shortcodePage: HTMLElement | null = document.querySelector('.shortcode');
        let origin: string | undefined;
        if (!shortcodePage) {
            return;
        }
        let mainDiv: HTMLElement | undefined;
        let height: number = 0;

        if (shortcodePage.classList.contains('internet_filter')) {
            origin = 'logitelshortcodeInternetFilter';
        } else if (shortcodePage.classList.contains('internet_interest')) {
            origin = 'logitelShortcodeInternetInterest';
        } else if (shortcodePage.classList.contains('mobilfunk_filter')) {
            origin = 'logitelshortcodeMobilfunkFilter';
        } else if (shortcodePage.classList.contains('mobilfunk_interest')) {
            origin = 'logitelShortcodeMobilfunkInterest';
        }
        mainDiv = shortcodePage.querySelector('#main') as HTMLElement;
        if (!mainDiv) {
            return;
        }

        mainDiv.style.minHeight = '100px';

        height = mainDiv.clientHeight;
        if (!origin) {
            return;
        }
        if (size !== 0) {
            this.postWindowMessage(origin, size);
            return;
        }
        this.postWindowMessage(origin, height);
    }

    private postWindowMessage(origin: string, height: number): void {
        window.parent.postMessage(
            {
                height: height,
                origin: origin,
            },
            '*',
        );
    }
}
